import { api } from '@/api/client';
import { createSpouseOnCrm } from '@/lib/spouse';
import { rsvpCreateSpouseRequestSchema, rsvpSubmissionSchema } from '@mr-website/schemas';
import { isAxiosError } from 'axios';
import { buildRsvpSubmission } from './buildRsvpSubmission';
import type { GuestRow } from './GuestSection';
import type { SpouseFormState } from './SpouseSection';
import { linkedSpouseFromProfile } from './utils';
import type { LinkedSpouse } from './types';

export async function submitRsvp({
  eventId,
  linkedSpouse,
  spouse,
  guests,
}: {
  eventId: string;
  linkedSpouse: LinkedSpouse | null;
  spouse: SpouseFormState;
  guests: GuestRow[];
}): Promise<{ createdSpouse: boolean }> {
  let effectiveLinkedSpouse = linkedSpouse;
  let createdSpouse = false;

  if (spouse.enabled && !linkedSpouse?.contact_id?.trim()) {
    const created = await createSpouseOnCrm(
      rsvpCreateSpouseRequestSchema.parse({
        first_name: spouse.fields.first_name,
        last_name: spouse.fields.last_name,
        email_address: spouse.fields.email,
      }),
    );
    effectiveLinkedSpouse = linkedSpouseFromProfile(created);
    createdSpouse = true;

    if (!effectiveLinkedSpouse?.contact_id) {
      throw new Error('Your spouse could not be linked. Please contact your advisor.');
    }
  }

  const payload = rsvpSubmissionSchema.parse(
    buildRsvpSubmission(effectiveLinkedSpouse, spouse, guests),
  );

  try {
    await api.post(`/events/${eventId}/rsvp`, payload);
    return { createdSpouse };
  } catch (error) {
    if (isAxiosError(error)) {
      const message = error.response?.data?.message;
      if (typeof message === 'string' && message.trim()) {
        throw new Error(message);
      }
    }
    throw error;
  }
}
